<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">
        <div class="flex">
          <div class="box flex" style="align-items:center">
            <div class="title">赠送人手机号：</div>
            <el-input
              style="width: 180px"
              size="small"
              v-model="give_mobile"
            ></el-input>
          </div>
          <div class="box flex" style="align-items:center">
            <div class="title">接收人手机号：</div>
            <el-input
              style="width: 180px"
              size="small"
              v-model="accept_mobile"
            ></el-input>
          </div>
        </div>
        <div class="flex">
          <div class="box flex">
            <div class="title">赠送时间：</div>
            <el-date-picker
              style="width: 160px;"
              v-model="dateValue[0]"
              type="date"
              class="date_picker_box"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <el-time-picker
              style="width: 160px;"
              placeholder="时间"
              v-model="timeValue[0]"
              class="time_picker_box"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              size="small"
            ></el-time-picker>
            <span style="margin-right:8px">至</span>
            <el-date-picker
              style="width: 160px;"
              v-model="dateValue[1]"
              type="date"
              class="date_picker_box"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
            <el-time-picker
              style="width: 160px;"
              placeholder="时间"
              v-model="timeValue[1]"
              class="time_picker_box"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              size="small"
            ></el-time-picker>
          </div>
        </div>

        <div class="flex">
          <div class="box flex">
            <el-button type="primary" size="small" @click="screen"
              >筛选</el-button
            >
            <el-button type="primary" size="small" @click="exportExcel"
              >导出</el-button
            >
          </div>
        </div>
      </div>
      <div class="bottom">
        <el-table
          v-loading="loading"
          :data="tableData"
          size="small"
          :header-cell-style="setHeader"
          height="100%"
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="give_mobile" label="赠送人"></el-table-column>
          <el-table-column label="接收人" prop="accept_mobile">
            <!-- <template slot-scope="scope">
              <div v-if="scope.row.coupon_type == 1">满减券</div>
              <div v-if="scope.row.coupon_type == 2">折扣券</div>
              <div v-if="scope.row.coupon_type == 3">代金券</div>
              <div v-if="scope.row.coupon_type == 4">兑换券</div>
              <div v-if="scope.row.coupon_type == 5">储值券</div>
              <div v-if="scope.row.coupon_type == 6">通用券</div>
              <div v-if="scope.row.coupon_type == 7">次数券</div>
            </template> -->
          </el-table-column>
          <el-table-column prop="title" label="券名称"></el-table-column>
          <el-table-column
            prop="coupon_type_name"
            label="券类型"
          ></el-table-column>

          <el-table-column prop="send_num" label="赠送数量"></el-table-column>
          <el-table-column
            prop="create_time"
            label="赠送时间"
          ></el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next, jumper"
          :total="total_num"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { exportMethod } from "@/api/vip";
import {
  couponVerifiy,
  coupon_gift_index,
  couponShop,
  couponCancle_expser,
} from "@/api/coupon";
export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  data() {
    return {
      loading: false,
      page: "1",
      total_num: 0,
      tableData: [],
      formLabelWidth: "120px",
      dialogFormVisible: false,
      give_mobile: "",
      accept_mobile: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000",
      },
      dateValue: [],
      timeValue: [],
    };
  },
  mounted() {
    this.getLists();
  },
  methods: {
    exportExcel() {
      if (this.dateValue.length > 1) {
        let a = new Date(this.dateValue[0]).getTime();
        let b = new Date(this.dateValue[1]).getTime();
        let c = b - a;
        if (Math.floor(c / 86400000) > 31) {
          this.$message("开始时间与结束时间,间隔不能超过一个月");
        } else {
          var data = {
            token: this.token,
            Api: "coupon/agent.coupon_data/coupon_gift_index",
            params: [
              { name: "app_id", value: this.app_id },
              { name: "export_", value: "1" },
              { name: "give_mobile", value: this.give_mobile },
              { name: "accept_mobile", value: this.accept_mobile },
              { name: "create_time_s", value: this.dateValue[0] },
              { name: "create_time_e", value: this.dateValue[1] },
            ],
          };
          console.log(data);
          exportMethod(data);
        }
      } else {
        this.$message("请选择时间");
      }
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    addSlice() {
      this.$router.push({
        path: `adSign`,
      });
    },
    // 筛选page
    screen() {
      this.page = 1;
      // if (
      //   this.dateValue.length > 1 &&
      //   new Date(this.dateValue[0]).getTime() >
      //     new Date(this.dateValue[1]).getTime()
      // ) {
      //   this.$message("开始时间不能大于结束时间");
      // } else {
      this.getLists();
      // }
    },
    // 核销记录
    getLists() {
      this.loading = true;
      let data = {
        token: this.token,
        app_id: this.app_id,
        give_mobile: this.give_mobile,
        accept_mobile: this.accept_mobile,
        limit: "10",
      };
      if (this.dateValue !== null && this.dateValue.length !== 0) {
        if (this.dateValue[0] != null) {
          data.create_time_s = this.timeValue[0]
            ? this.dateValue[0] + " " + this.timeValue[0]
            : this.dateValue[0] + " 00:00:00";
          data.create_time_e = this.timeValue[1]
            ? this.dateValue[1] + " " + this.timeValue[1]
            : this.dateValue[1] + " 23:59:59";
        }
      }
      coupon_gift_index(data).then((res) => {
        console.log("sss", res);
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data.result;
          this.total_num = res.data.total_num;
          // this.count = res.data.count;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  overflow: auto;
  min-width: 900px;
  border: node;
  // background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 0 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .header {
      padding-top: 20px;
      margin-bottom: 20px;
      .box {
        // width: 330px;
        .title {
          min-width: 100px;
          text-align: right;
        }
        .fixedwidth {
          width: 180px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .bottom {
      flex: 1;
      overflow-y: scroll;
    }
    .page {
      height: 50px;
      display: flex;
      align-items: center;
    }
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 3px 0px;
}
.el-table td {
  // padding: 12px 0;
}
</style>
